export default {
      id: "ar_recrutement-usage",
      viewBox: "0 0 90 90",
      url: "../dist/images/" + "sprite.svg#ar_recrutement-usage",
      toString: function () {
        return this.url;
      }
    }